export default __webpack_public_path__ + "static/tag-dont-2-light-98dfaa770d41378aecd3ea8723784db4.png";